const portalOptions = [
  { label: 'QTE Auto', path: '/QTE' },
  { label: 'FCS Auto', path: '/FCS' },
  { label: 'Acevalor', path: '/ACE' }
]
const companyOptions = {
  QTE: { name: 'QTE', path: '/QTE' },
  FCS: { name: 'FCS', path: '/FCS' },
  ACE: { name: 'ACE', path: '/ACE' }
}
const UserRole = {
  Admin: { label: 'Admin', value: 'admin' },
  WarehouseSO: { label: 'Warehouse SO', value: 'warehouse-so' },
  WarehouseM: { label: 'Warehouse M', value: 'warehouse-m' },
  WarehouseTOPO: { label: 'Warehouse To&Po', value: 'warehouse-to-po' },
  WarehouseChina: { label: 'Warehouse China Office', value: 'warehouse-china' }
}
const userRoles = [
  { label: 'Admin', value: 'admin' },
  { label: 'Warehouse SO', value: 'warehouse-so' },
  { label: 'Warehouse M', value: 'warehouse-m' },
  { label: 'Warehouse To&Po', value: 'warehouse-to-po' },
  { label: 'Warehouse China Office', value: 'warehouse-china' }
]
const companies = ['QTE', 'FCS', 'ACE']
enum Company {
  QTE = 'QTE',
  FCS = 'FCS',
  ACE = 'ACE'
}
const operationOptions = [
  {
    label: 'Daily Order',
    path: '/daily-order',
    block: [UserRole.WarehouseTOPO.value]
  },
  {
    label: 'Sales Order',
    path: '/sales-order',
    block: [UserRole.WarehouseTOPO.value]
  },
  {
    label: 'Purchase Order Receiving',
    path: '/purchase-order-receiving',
    block: [UserRole.WarehouseSO.value, UserRole.WarehouseChina.value]
  },
  {
    label: 'Transfer Order',
    path: '/transfer-order',
    block: [UserRole.WarehouseChina.value]
  },
  {
    label: 'Item Lookup',
    path: '/item-lookup'
  }
]
enum OperationPath {
  SalesOrderPicking = '/sales-order-picking',
  PurchaseOrderReceiving = '/purchase-order-receiving',
  TransferOrderPicking = '/transfer-order-picking',
  TransferOrderFBAPrint = '/transfer-order-fba-print'
}

/**
 * Operation type enum - represents the type of operation being performed
 * This is more explicit than inferring from URL path
 */
enum OperationType {
  SalesOrderPicking = 'sales-order-picking',
  PurchaseOrderReceiving = 'purchase-order-receiving',
  TransferOrderPicking = 'transfer-order-picking',
  TransferOrderFBAPrint = 'transfer-order-fba-print'
}
const dailyOrderOperations = [
  {
    label: 'Single Item Order',
    path: '/daily-order/single-item-order'
  },
  {
    label: 'Multiple Item Order (without box code)',
    path: '/daily-order/multiple-item-order-without-box'
  },
  {
    label: 'Multiple Item Order (with box code)',
    path: '/daily-order/box-code-order'
  },
  {
    label: 'Special Order',
    path: '/daily-order/special-order'
  },
  {
    label: 'Daily Order Search And Scan',
    path: '/daily-order/search'
  },
  {
    label: 'View Order Cancellation Request',
    path: '/daily-order/order-cancellation',
    block: [UserRole.WarehouseSO.value]
  },
  { label: 'View Daily Order List', path: '/daily-order/daily-order-list' },
  { label: 'View Box List', path: '/daily-order/box/box-list' }
]
const manageDailyOrderOperations = [
  {
    label: 'Synchronize Order From NetSuite',
    path: '/daily-order/sync-daily-order'
  },
  {
    label: 'Synchronize Order History',
    path: '/daily-order/sync-order-history'
  },
  {
    label: 'Add Or Update Daily Order',
    path: '/daily-order/add-or-update-daily-order'
  }
]
const uploadOperations = [
  { label: 'Add Single Item Order', value: 'single-item-order' },
  { label: 'Add Multiple Items Order', value: 'multiple-items-order' },
  { label: 'Add Box Code Order', value: 'box-code-order' },
  { label: 'Mark Orders As Special', value: 'mark-code-special' }
]

const boxOperations = [
  {
    label: 'Pick Items to Box',
    path: '/daily-order/box-code-order/pick-item-to-box'
  },
  {
    label: 'Fulfill Order With Box Code',
    path: '/daily-order/box-code-order/fulfill-order'
  }
]
enum DailyOrderType {
  SingleItemSalesOrder = 'single-item-order',
  MultipleItemsSalesOrder = 'multiple-items-order',
  BoxCodeSalesOrder = 'box-code-order',
  SpecialOrder = 'special-order',
  All = 'all'
}
enum ItemScanError {
  ExceedMax = 'exceed_max',
  InvalidUpc = 'invalid_upc',
  NoInventory = 'no_inventory'
}

enum DailyOrderStatus {
  PendingFulfilled = 'pending-fulfilled',
  Finished = 'finished',
  PendingCancelled = 'pending-cancelled',
  CancelConfirmed = 'cancel-confirmed',
  FailedToCancel = 'failed-to-cancel'
}

enum SnackbarSeverity {
  Success = 'success',
  Error = 'error',
  Warning = 'warning',
  Info = 'info'
}
enum UserActionType {
  CreateOrder = 'create-order',
  SyncOrder = 'sync-order',
  DeleteOrder = 'delete-order',
  RequestCancelOrder = 'request-cancel-order',
  ConfirmCancelOrder = 'confirm-cancel-order',
  RefuseCancelOrder = 'refuse-cancel-order',
  FulfillOrder = 'fulfill-order'
}

const locations = [{ id: 1, value: 'GA-01', company: 'QTE' }]

export {
  operationOptions,
  portalOptions,
  companyOptions,
  companies,
  Company,
  ItemScanError,
  OperationPath,
  OperationType,
  UserRole,
  userRoles,
  DailyOrderType,
  uploadOperations,
  dailyOrderOperations,
  manageDailyOrderOperations,
  DailyOrderStatus,
  boxOperations,
  locations,
  SnackbarSeverity,
  UserActionType
}
